function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var CryptoSelectAmountTemplate = require('./select-amount.template');
var CryptoSelectAmount = /*#__PURE__*/function () {
  function CryptoSelectAmount(app, mod) {
    var mycallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, CryptoSelectAmount);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.callback = mycallback;
    this.fixed = true;
    this.ticker = '';
    this.stake = 0;
    this.one_sided = false;
    this.player1_stake = '0';
    this.player2_stake = '0';
  }
  return _createClass(CryptoSelectAmount, [{
    key: "bindSelectOnZeroFocus",
    value: function bindSelectOnZeroFocus(input) {
      if (!input) {
        return;
      }
      var selectIfZero = function selectIfZero() {
        if (parseFloat(input.value) === 0) {
          input.select();
        }
      };
      input.addEventListener('focus', selectIfZero);
      input.addEventListener('click', selectIfZero);
    }
  }, {
    key: "render",
    value: function render() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (mycallback != null) {
        this.callback = mycallback;
      }
      if (!this.ticker) {
        this.ticker = this.app.wallet.returnPreferredCryptoTicker();
      }
      this.overlay.show(CryptoSelectAmountTemplate(this.app, this.mod, this));
      this.overlay.blockClose('#enable_staking_yes');
      this.attachEvents();
    }
  }, {
    key: "refreshForm",
    value: function refreshForm() {
      this.app.browser.replaceElementById(CryptoSelectAmountTemplate(this.app, this.mod, this), 'stake-crypto-request-container');
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var toggle = document.getElementById('stake-mode-toggle');
      if (toggle) {
        toggle.onclick = function (e) {
          e.preventDefault();
          _this.toggleStakeMode();
        };
      }
      var stake_input = document.getElementById('amount_to_stake_input');
      if (stake_input) {
        this.bindSelectOnZeroFocus(stake_input);
        stake_input.onkeydown = function (e) {
          _this.app.browser.validateAmountLimit(stake_input.value, e);
        };
        stake_input.onblur = function () {
          _this.validateAmount();
        };
        stake_input.oninput = function () {
          var _document$querySelect;
          if (((_document$querySelect = document.querySelector('#stake-amount-error')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.style.display) === 'block') {
            _this.validateAmount();
          }
        };
      }
      var player1_input = document.getElementById('player1_stake_input');
      var player2_input = document.getElementById('player2_stake_input');
      if (player1_input) {
        this.bindSelectOnZeroFocus(player1_input);
        player1_input.onkeydown = function (e) {
          _this.app.browser.validateAmountLimit(player1_input.value, e);
        };
        player1_input.onblur = function () {
          _this.validateAmount();
        };
        player1_input.oninput = function () {
          var _document$querySelect2;
          if (((_document$querySelect2 = document.querySelector('#stake-amount-error')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.style.display) === 'block') {
            _this.validateAmount();
          }
        };
      }
      if (player2_input) {
        this.bindSelectOnZeroFocus(player2_input);
        player2_input.onkeydown = function (e) {
          _this.app.browser.validateAmountLimit(player2_input.value, e);
        };
        player2_input.onblur = function () {
          _this.validateAmount();
        };
        player2_input.oninput = function () {
          var _document$querySelect3;
          if (((_document$querySelect3 = document.querySelector('#stake-amount-error')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.style.display) === 'block') {
            _this.validateAmount();
          }
        };
      }
      var confirm_btn = document.querySelector('#enable_staking_yes');
      if (confirm_btn) {
        confirm_btn.onclick = function () {
          if (!_this.validateAmount()) {
            return;
          }
          if (_this.callback != null) {
            if (_this.one_sided) {
              var _document$getElementB, _document$getElementB2, _document$getElementB3, _document$getElementB4;
              var p1 = (_document$getElementB = (_document$getElementB2 = document.getElementById('player1_stake_input')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value) !== null && _document$getElementB !== void 0 ? _document$getElementB : _this.player1_stake;
              var p2 = (_document$getElementB3 = (_document$getElementB4 = document.getElementById('player2_stake_input')) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.value) !== null && _document$getElementB3 !== void 0 ? _document$getElementB3 : _this.player2_stake;
              _this.callback(_this.ticker, p1, p2);
            } else {
              var _document$getElementB5, _document$getElementB6;
              var amount = (_document$getElementB5 = (_document$getElementB6 = document.getElementById('amount_to_stake_input')) === null || _document$getElementB6 === void 0 ? void 0 : _document$getElementB6.value) !== null && _document$getElementB5 !== void 0 ? _document$getElementB5 : _this.stake;
              _this.callback(_this.ticker, amount, null);
            }
          }
          _this.overlay.close();
        };
      }
      var crypto_select = document.querySelector('#stake-select-crypto');
      if (crypto_select) {
        crypto_select.onchange = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var _this$mod$balances$_t;
            var cm, balance;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this.captureInputValues();
                  _this.ticker = e.target.value;
                  if (_this.mod.balances[_this.ticker]) {
                    _context.n = 3;
                    break;
                  }
                  cm = _this.app.wallet.returnCryptoModuleByTicker(_this.ticker);
                  if (!cm) {
                    _context.n = 2;
                    break;
                  }
                  _context.n = 1;
                  return cm.getAvailableBalance();
                case 1:
                  balance = _context.v;
                  _this.mod.balances[_this.ticker] = {
                    address: cm.formatAddress(),
                    balance: balance
                  };
                  _context.n = 3;
                  break;
                case 2:
                  _this.mod.balances[_this.ticker] = {
                    address: '',
                    balance: '0'
                  };
                case 3:
                  _this.mod.max_balance = parseFloat((_this$mod$balances$_t = _this.mod.balances[_this.ticker]) === null || _this$mod$balances$_t === void 0 ? void 0 : _this$mod$balances$_t.balance) || 0;
                  _this.refreshForm();
                case 4:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "captureInputValues",
    value: function captureInputValues() {
      if (this.one_sided) {
        var _document$getElementB7, _document$getElementB8, _document$getElementB9, _document$getElementB0;
        this.player1_stake = (_document$getElementB7 = (_document$getElementB8 = document.getElementById('player1_stake_input')) === null || _document$getElementB8 === void 0 ? void 0 : _document$getElementB8.value) !== null && _document$getElementB7 !== void 0 ? _document$getElementB7 : this.player1_stake;
        this.player2_stake = (_document$getElementB9 = (_document$getElementB0 = document.getElementById('player2_stake_input')) === null || _document$getElementB0 === void 0 ? void 0 : _document$getElementB0.value) !== null && _document$getElementB9 !== void 0 ? _document$getElementB9 : this.player2_stake;
      } else {
        var _document$getElementB1, _document$getElementB10;
        this.stake = (_document$getElementB1 = (_document$getElementB10 = document.getElementById('amount_to_stake_input')) === null || _document$getElementB10 === void 0 ? void 0 : _document$getElementB10.value) !== null && _document$getElementB1 !== void 0 ? _document$getElementB1 : this.stake;
      }
    }
  }, {
    key: "toggleStakeMode",
    value: function toggleStakeMode() {
      this.captureInputValues();
      if (!this.one_sided) {
        var _document$getElementB11;
        this.player1_stake = ((_document$getElementB11 = document.getElementById('amount_to_stake_input')) === null || _document$getElementB11 === void 0 ? void 0 : _document$getElementB11.value) || this.stake || '0';
        if (this.player2_stake === undefined || this.player2_stake === '') {
          this.player2_stake = '0';
        }
        this.one_sided = true;
      } else {
        var _document$getElementB12;
        this.stake = ((_document$getElementB12 = document.getElementById('player1_stake_input')) === null || _document$getElementB12 === void 0 ? void 0 : _document$getElementB12.value) || this.player1_stake || '0';
        this.one_sided = false;
      }
      this.refreshForm();
    }
  }, {
    key: "validateAmount",
    value: function validateAmount() {
      var input_err = document.querySelector('#stake-amount-error');
      if (!input_err) {
        return true;
      }
      var errorMsg = '';
      input_err.innerText = '';
      input_err.style.display = 'none';
      if (this.one_sided) {
        var _document$getElementB13, _document$getElementB14, _document$getElementB15, _document$getElementB16;
        var p1 = parseFloat((_document$getElementB13 = (_document$getElementB14 = document.getElementById('player1_stake_input')) === null || _document$getElementB14 === void 0 ? void 0 : _document$getElementB14.value) !== null && _document$getElementB13 !== void 0 ? _document$getElementB13 : this.player1_stake);
        var p2 = parseFloat((_document$getElementB15 = (_document$getElementB16 = document.getElementById('player2_stake_input')) === null || _document$getElementB16 === void 0 ? void 0 : _document$getElementB16.value) !== null && _document$getElementB15 !== void 0 ? _document$getElementB15 : this.player2_stake);
        if (Number.isNaN(p1) || p1 < 0 || Number.isNaN(p2) || p2 < 0) {
          errorMsg = 'stakes must be zero or greater';
        } else if (p1 <= 0 && p2 <= 0) {
          errorMsg = 'at least one player needs a stake greater than zero';
        } else if (p1 > this.mod.max_balance) {
          errorMsg = "you don't have that much to stake for player 1";
        }
      } else {
        var _ref2, _document$getElementB17, _document$getElementB18;
        var amount = parseFloat((_ref2 = (_document$getElementB17 = (_document$getElementB18 = document.getElementById('amount_to_stake_input')) === null || _document$getElementB18 === void 0 ? void 0 : _document$getElementB18.value) !== null && _document$getElementB17 !== void 0 ? _document$getElementB17 : this.stake) !== null && _ref2 !== void 0 ? _ref2 : '0');
        if (amount <= 0) {
          errorMsg = 'you need to select a positive value';
        } else if (amount > this.mod.max_balance) {
          if (this.fixed) {
            errorMsg = 'not all the players have that much to stake';
          } else {
            errorMsg = "you don't have that much to stake";
          }
        }
      }
      if (errorMsg) {
        input_err.innerText = errorMsg;
        input_err.style.display = 'block';
        return false;
      }
      return true;
    }
  }]);
}();
module.exports = CryptoSelectAmount;